import { BrandCode, CommonConfig, SharedCommonConfig } from 'types';

const sharedConfig: SharedCommonConfig = {
	imageBaseUrl: 'https://assets.dm.rccl.com/is/image/RoyalCaribbeanCruises',
};

const config: CommonConfig = {
	endpoints: {
		cruiseSearchApi: '/graph',
		cruiseStandaloneSearchApi: '/cruises/graph',
		globalizationApi: '/graph',
		campaignsApi: '/graph',
		cruiseSearchTimeout: 20000,
		eventsApi: '/api/events',
		gdpApi: '/gdp/api',
		nlsApi: '/intelligence/api/v1/cruises/search',
		userEmailOnlyLoginApi: '/experiential-cart/api/identity/v1/login',
		userEmailOnlyValidateApi: '/experiential-cart/api/identity/v1/validate',
		userFavoritesApi: '/experiential-cart/api/dashboard/v1/favorites',
		userMergeApi: '/experiential-cart/api/dashboard/v1/user/merge',
		userWatchlistApi: '/experiential-cart/api/dashboard/v1/triggers',
		quickBookApi: '/room-selection/rooms-and-guests',
	},
	externalUrls: {
		shipReviews: '/cruise-ships/',
	},
	dictionaries: {
		cruiseSearchClient: 'cruise-search/client',
		booking: 'booking/forgot-casid-modal',
		bookingErrors: 'booking/forgot-casid-modal/errors',
	},
	publicKeys: {
		cookieRwdAudienceToken: 'e8b9ab34-0a30-4106-ac63-1d21f2664b4a',
		cookieTdAudienceToken: 'd8b9f43c-ff9b-4c86-a949-2d5b70cd9732',
	},
	brands: {
		[BrandCode.Celebrity]: {
			imageBaseUrl: sharedConfig.imageBaseUrl,
			endpoints: {
				bookingApi: '/booking-cruise/selectRoom',
				universalNavigationApi: '/bin/services/celebrity/selector/',
			},
		},
		[BrandCode.RoyalCaribbean]: {
			imageBaseUrl: sharedConfig.imageBaseUrl,
			endpoints: {
				bookingApi: '/booking/landing',
				universalNavigationApi: '/bin/services/royal/selector/',
			},
		},
	},
};

export default config;
